export default __webpack_public_path__ + "static/desk01-5e59a3e59ba3bfdd380d2ecb54a83a77.png";